import React from "react";
import PropTypes from "prop-types";
import { ThemeContext } from '../../../constants/themes';
import Button from '../../atoms/Button';
import Type from '../../atoms/Type';
import "./index.css";

const Modal = (props) => {
   if (!props.show) {
      return null;
   }
   return (
      <ThemeContext.Consumer>
         {themeContext => (
            <>
               <div className="modal-background">
               </div>
               <div className="modal-inner-background">
                  <div className="modal" id="modal" style={{borderColor: themeContext.theme.text, backgroundColor: themeContext.theme.body}}>
                     <div className="modal-header">
                        <Type type="h2" style={{margin: 0}}>{props.title}</Type>
                        <Button type="secondary" value={props.closeText || 'Close'} onClick={props.onClose} />
                     </div>
                     {props.children}
                  </div>
               </div>
            </>
         )}
      </ThemeContext.Consumer>
   );
}

Modal.propTypes = {
   title: PropTypes.string.isRequired,
   closeText: PropTypes.string,
   onClose: PropTypes.func.isRequired,
   show: PropTypes.bool.isRequired
}

export default Modal;